import "./select.css.ts.vanilla.mjs";
var _ = "p273__select-3517_fc5ade93b__91k6ak1", a = "p273__select-3517_fc5ade93b__91k6ak0", t = "p273__select-3517_fc5ade93b__91k6ak2";
export {
  _ as darkTheme,
  a as lightTheme,
  t as selectStyle
};
//# sourceMappingURL=select.mjs.map
